import type { RouteObject } from "react-router-dom";

export const calendarPath = "/calendar";

export const calendarRoute: RouteObject = {
    path: calendarPath,
    lazy: async () => {
        const { CalendarPage } = await import("@/features/calendar/page");
        return { Component: CalendarPage };
    },
};
